import { useQuery } from '@tanstack/react-query';

import { getCtrData } from '../api/ventura/contract';
import { useConfig } from './useConfig';

function useContractPacingData(contractId: number) {
  const { apiHost } = useConfig();

  const query = useQuery({
    queryKey: ['contractCtrData', contractId],
    queryFn: () => getCtrData(apiHost, contractId),
  });

  return query;
}

export default useContractPacingData;
